import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { PromotionService, ContractItemModel, BannerContract, PagerService, AlertService, TableHeader, CommonService } from '../../../services/index'
import { Util } from '../../../utils'
import _ from 'lodash';

declare var $:any;
declare var moment:any;

@Component({
  selector: 'contract-list',
  templateUrl: 'contract-list.html'
})
export class ContractListComponent {
  getContractListSub:Subscription;

  contractList: Array<ContractItemModel> = [];
  tempContractList = new Array();
  headerList:Array<TableHeader> = null;
  showBannerContractList: Array<boolean> = [];
  
  pager: any = {};
  pagedItems:any[];
  searchOption:SearchOption = new SearchOption();

  selectedContract: BannerContract;
  selectedContractCopied: BannerContract;
  cIndex: number;
  bIndex: number;

  isEditing: boolean = false;

  accountCountries: Array<string> = [];

  numberWithCommas:Function = Util.numberWithCommas;
  dateFomatter:Function = Util.dateFomatter;

  today = moment().format('YYYYMMDD');

  constructor(
    private promotionService : PromotionService,
    private pagerService: PagerService,
    private alertService:AlertService,
    private commonService: CommonService,
  ) {
    this.makeHeader();
    commonService.headerSortedEmit.subscribe(sortedData =>{
      this.tempContractList = sortedData;
      this.setPage(1);
    });
    commonService.clearHeaderEmit.subscribe(headers =>{
      this.headerList = headers;
    });
  } 

  makeHeader(){
    this.headerList = new Array<TableHeader>();
    this.headerList.push(new TableHeader(0, '', '상태', false));
    this.headerList.push(new TableHeader(1, 'corporation.typeCd', '구분', true));
    this.headerList.push(new TableHeader(2, 'corporation.corpNm', '회사명', true));
    this.headerList.push(new TableHeader(3, 'startDt', '계약기간', false));
    this.headerList.push(new TableHeader(4, 'activityCountryCnt', '계약 수량', true));
    this.headerList.push(new TableHeader(5, 'contractAmount', '계약금액', true));
    this.headerList.push(new TableHeader(6, 'sellAmount', '판매금액', true));
    this.headerList.push(new TableHeader(7, '', '비고', false));
    this.headerList.push(new TableHeader(8, '', '삭제', false));
  }
  

  ngOnInit() {
    this.search(1);
  }

  handleKeyDown(event){
    if(event.keyCode == 13) this.conditionSearch(1);
  }

  search(page){
    this.getContractListSub = this.promotionService.getContractList().subscribe((res:any)=>{
      this.contractList = res.data;

      this.contractList = _.map(this.contractList, 
        (item:ContractItemModel) => {
          item.bannerContractList = _.orderBy(item.bannerContractList, ['countryName', 'startDt'], ['asc', 'asc']);
          return item;
      })

      this.tempContractList = this.contractList;
      if(this.searchOption.conditionText && this.searchOption.conditionText.length > 0){
        this.conditionSearch(page);
      } else {
        this.setPage(page);
      };

      if(this.contractList != null) {
        for(let contract of this.contractList) {
          this.showBannerContractList.push(false);
        };
      };
    });
  }
  

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.tempContractList.length, page);
    // if (page < 1) {
    //   return;
    // } 
    
    this.pagedItems = this.tempContractList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  
  conditionSearch(page){    
    if(_.isEmpty(this.contractList)) return ;
    
    this.tempContractList = new Array();
    for(let i=0; i<this.contractList.length; i++){
      let contract:ContractItemModel = _.cloneDeep(this.contractList[i]);

      let temp = _.map(_.filter(contract.bannerContractList, (bc:BannerContract) => {
        if((this.isExistCountry(bc) || this.isExistCorpName(bc)) && this.isExistStatus(bc) && this.isExistBetweenDate(bc)) return true;
      }));

      contract.bannerContractList = temp;
      if(temp != null && temp.length > 0){
        this.tempContractList.push(contract);
      }
    }
    
    this.setPage(page);
    this.commonService.clearOrderByHeader(this.headerList);
  }

  isExistBetweenDate(bannerContract:BannerContract){
    let isExist = false

    let contractStrDt:Date = moment(bannerContract.startDt).format('YYYYMMDD');
    let contractEndDt:Date = moment(bannerContract.endDt).format('YYYYMMDD');
    let conditionStrDt:Date = moment(this.searchOption.startDt).format('YYYYMMDD');
    let conditionEndDt:Date = moment(this.searchOption.endDt).format('YYYYMMDD');


    if(this.searchOption.searchType == 0){
      if(contractStrDt >= conditionStrDt && (contractEndDt <= conditionEndDt || bannerContract.endDt == null || bannerContract.endDt.indexOf('21000101') > -1)){
        return true;
      }
    }else {
      if(contractStrDt <= conditionStrDt && (contractEndDt >= conditionEndDt || bannerContract.endDt == null || bannerContract.endDt.indexOf('21000101') > -1 )){
        return true;
      }
    }

    return isExist;
  }


  isExistCountry(bannerContract: BannerContract) {
    let isExist = false;

    let keyword = _.upperCase(this.searchOption.conditionText).replace(/\s/gi, "");
    
    if(_.upperCase(bannerContract.countryCode).replace(/\s/gi, "").indexOf(keyword) >= 0) {
      return true;
    } else if (_.upperCase(bannerContract.countryName).replace(/\s/gi, "").indexOf(keyword) >= 0) {
      return true;
    }

    return isExist;
  }

  isExistCorpName(bannerContract: BannerContract) {
    let isExist = false;

    let keyword = _.upperCase(this.searchOption.conditionText).replace(/\s/gi, "");
    
    if(_.upperCase(bannerContract.corporation.corpNm).replace(/\s/gi, "").indexOf(keyword) >= 0) {
      return true;
    }

    return isExist;
  }

  
  isExistStatus(bannerContract: BannerContract) {

    let isExist = false;
    let condition = this.searchOption.conditionType;

    if(condition == 0){
      return true;
    }else if(condition == 1 && bannerContract.startDt != null && bannerContract.startDt > this.today){
      return true;
    }else if(condition == 2 && bannerContract.startDt != null && bannerContract.startDt <= this.today && bannerContract.endDt == null){
      return true;
    }else if(condition == 3 && bannerContract.startDt != null && bannerContract.startDt <= this.today && bannerContract.endDt != null && bannerContract.endDt > this.today){
      return true;
    } else if(condition == 4 && bannerContract.endDt != null && bannerContract.endDt <= this.today){
      return true;
    } 
    
    return isExist;
  }

  selectConditionType(event) {
    this.searchOption.conditionType = event;
    this.conditionSearch(1);
  }

  selectSearchType(event) {
    this.searchOption.searchType = event;
    this.conditionSearch(1);
  }

  addNewContract() {
    this.selectedContract = new BannerContract();
    this.isEditing = false;
    $('body').css('overflow', 'hidden');
  }

  editContract(contract, i, k) {
    this.selectedContract = contract;
    this.selectedContractCopied = _.clone(contract);
    this.cIndex = i;
    this.bIndex = k;
    this.isEditing = true;
    $('body').css('overflow', 'hidden');
  }

  hideContractDetail(event) {
    this.selectedContract = null;
    this.isEditing = false;
    
    $('body').css('overflow', 'visible'); 

    if(event == null) {
      if(this.cIndex != null && this.bIndex != null) this.pagedItems[this.cIndex].bannerContractList[this.bIndex] = this.selectedContractCopied;
    } else if(event == 'add' || event == 'save') {
      this.search(1);
    }

    
  }

  handleClickContract(i) {
    if(this.showBannerContractList[i]) {
      this.showBannerContractList[i] = false;
    } else {
      this.showBannerContractList[i] = true;
    }
  }
  

  deleteContract(bannerContractId) {
    let that = this;
    $.sweetModal.confirm('계약을 삭제하시겠습니까?', function() {
      that.promotionService.deleteContract(bannerContractId).subscribe(
        resp => {
          if(resp.result) {
            that.alertService.success('삭제되었습니다.');
            that.search(1);
          } else {
            that.alertService.error(resp.errorMsg);
          }
        }
      )
    }, function() {
    });
  }

  parseToDate(dateStr:string) {
    return moment(dateStr, 'YYYYMMDD').toDate();
  }

  setStartDtm($event) {
    this.searchOption.startDt = moment($event).format('YYYYMMDD');
    this.conditionSearch(1);
  }

  setEndDtm($event) {
    this.searchOption.endDt = moment($event).format('YYYYMMDD');
    this.conditionSearch(1);
  }

  ngOnDestroy() {
    if(this.getContractListSub) this.getContractListSub.unsubscribe();
  }


}

class SearchOption {
  searchType: number = 0;
  conditionText:string;
  conditionType: number = 0;
  // startDt:string = moment(new Date()).add(-1, 'Y').format('YYYYMMDD');
  startDt:string = '20180101';
  endDt:string = moment(new Date()).add(1, 'Y').format('YYYYMMDD');
}


// WEBPACK FOOTER //
// ./src/app/containers/promotion/contract/contract-list.ts